<template lang="pug">
  .gl-color-picker(layout="row" layout-align="space-between center")
    .gl-color-picker__hex(flex) {{ color.hex }}
    div(:id="popoverId" layout="row" layout-align="start center")
      .gl-color-picker__color(:style="{ backgroundColor: color.hex }")
      .gl-color-picker__click(:class="{ 'active': popoverIsOpen }")
        span(v-if="!popoverIsOpen") Choose a color
        span(v-if="popoverIsOpen") Hide color picker
      b-popover(
        :target="popoverId"
        :placement="'top'"
        @shown="popoverIsOpen = true"
        @hidden="popoverIsOpen = false"
        tabindex="0"
        triggers="click")
        chrome-picker(v-model="color" @input="updateHex")
</template>

<script>
import _ from 'lodash'

export default {

  // props
  props: {
    hex: String
  },

  // inserted
  inserted () {
    // bind color
    this.color = { hex: this.hex }
  },

  // computed
  computed: {
    popoverId () {
      return 'gl-color-picker--' + _.random(0, 1000000)
    }
  },

  // data
  data () {
    return {
      color: '',
      pristineHex: null,
      popoverIsOpen: false
    }
  },

  // watch
  watch: {
    hex (hex) {
      // bind color
      this.color = { hex }
    }
  },

  // methods
  methods: {
    updateHex (val) {
      // emit event
      this.$emit('hex-updated', val.hex)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../styles/colors';
  @import '../styles/variables';

  .gl-color-picker {
    background: #F9FAFB;
    border: 1px solid $gl-grey-border;
    border-radius: 3px;
    height: 36px;
    margin-bottom: 20px;
    box-shadow: $gl-box-shadow-light;

    &__hex, &__click {
      font-weight: 400;
      color: $gl-grey-darker;
    }

    &__color {
      height: 36px;
      width: 36px;
      cursor: pointer;
      border: 1px solid $gl-grey-border;
    }

    &__hex {
      padding: 0 10px;
    }

    &__click {
      padding: 9px 14px;
      cursor: pointer;
      height: 34px;
      margin-left: -1px;
      transition: all 0.15s;
      &:hover {
        text-decoration: underline;
        background-color: $gl-grey-border;
      }
      &.active {
        background-color: $gl-grey-border;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/gl-color-picker.vue